import type { PropsWithChildren } from 'react';

import { Text as DesignSystemText } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Button } from './Button';

export type TextProps = PropsWithChildren<{
	type: 'text';
	label: string;
	description: string;
	selected: boolean;
	onClick: () => void;
	Radio?: React.FC | undefined;
}>;

export function Text({ label, description, selected, onClick, Radio }: Omit<TextProps, 'type'>): JSX.Element {
	return (
		<Button selected={selected} onClick={onClick} className="p-7 text-left" data-testid="selection-card-text-button">
			<div className={cn({ 'flex items-start gap-3 self-stretch': !!Radio })}>
				{Radio && <Radio />}
				<div className="flex flex-col gap-2">
					<DesignSystemText variant="body" fontWeight="bold">
						{label}
					</DesignSystemText>
					<div className={cn({ 'text-typography-strong': selected, 'text-typography-weak': !selected })}>
						<DesignSystemText variant="body">{description}</DesignSystemText>
					</div>
				</div>
			</div>
		</Button>
	);
}
